import React from 'react';
import styled from 'styled-components';

import colors from '~/constants/colors';

interface TitleProps {
  text: string;
  subtext?: string;
  textColor?: string;
}

const Title = ({ text, subtext, textColor }: TitleProps) => {
  return (
    <Container textColor={textColor} className="Title">
      <span className="Text">{text}</span>
      {subtext && <span className="Subtext">{subtext}</span>}
    </Container>
  );
};

const Container = styled.h1<{ textColor?: string }>`
  font-weight: 600;
  font-size: 38px;
  line-height: 1.25em;
  margin-top: 32px;
  margin-bottom: 64px;

  .Text {
    display: block;
    color: ${({ textColor }) => textColor ?? colors.primaryColor} !important;
  }
  .Subtext {
  }
`;

export default Title;
